import React from "react";
import { useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { UiPopup } from "../../../_uiComponents/common/UiModal";
import { ConfirmationIcon } from "../../../../styles/img/svg/ConfirmationIcon";
import { UiButton } from "../../../_uiComponents/common/UiButton";
import { SomethingWrongModal } from "../../../_uiComponents/Popups/SomethingWrongModal";
import { ConfirmationPopupOnboard } from "../../../_uiComponents/Popups/ConfirmationPopupOnboard";

export const AlreadyCustomer = (props) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <UiPopup openModal={props?.isOpen}>
        <ConfirmationPopupOnboard
          icon={<ConfirmationIcon />}
          message={t("You are already a LOLC Customer")}
          buttonOneClick={() => {
            props?.handleClose(false);
          }}
          className="df-confirmation-message-popup df-btn-grpdmodal"
        >
          <p>
            <Trans
              i18nKey={t(
                "It seems you are already a LOLC customer. Try logging in with your existing credentials.",
              )}
            />
            <br />
            <br />
            {/* <Trans
              i18nKey={t("onboarding_recover_msg")}
              components={{
                1: (
                  <a
                    href={"/forgot-username"}
                    className="df-primary-underlined-btn  mt-1 mb-1"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/forgot-username");
                    }}
                  />
                ),
              }}
            /> */}
          </p>
          <p className="mb-0 mt-1">
            {t("For further assistance, please contact")}
          </p>
          <a
            className="df-primary-underlined-btn  mt-0 mb-0"
            href={`tel:${process.env.SUPPORT_CENTER_CONTACT_NUMBER}`}
          >
            {process.env.SUPPORT_CENTER_CONTACT_NUMBER_LABEL}
          </a>
        </ConfirmationPopupOnboard>
      </UiPopup>
    </>
  );
};
